import { cn } from "@/lib/utils";

function GradientBackground() {
	return (
		<div className="pointer-events-none fixed inset-0 overflow-hidden bg-background">
			<BackgroundGradient className="opacity-15" />
			<BackgroundGradient className="opacity-100 mix-blend-soft-light" />
		</div>
	);
}

function BackgroundGradient({ className }: { className?: string }) {
	return (
		<div
			className={cn(
				"absolute left-0 top-0 aspect-square w-full overflow-hidden sm:aspect-2/1",
				"mask-[radial-gradient(70%_100%_at_50%_0%,black_70%,transparent)]",
				className,
			)}
		>
			<div
				className="absolute inset-0 saturate-150"
				style={{
					backgroundImage:
						"conic-gradient(from -45deg at 50% -10%, #3A8BFD 0deg, #FF0000 172.98deg, #855AFC 215.14deg, #FF7B00 257.32deg, #3A8BFD 360deg)",
				}}
			/>
			<div className="absolute inset-0 backdrop-blur-[100px]" />
		</div>
	);
}

export { GradientBackground };
